import BaseModel from "../default/base-model";
import {Client} from "./client";
import {SelectItem} from "./select-item";
import {Lob} from "./asset-control";

export class Project extends BaseModel {
    id?: number;
    name: string;
    active: boolean;
    url: string;
    part_numbers: PartNumber[];
    client: Client;
    lob: Lob;
    budget: number;
    formatted_budget?: string

    constructor() {
        super();
        this.id = undefined;
        this.name = "";
        this.active = true;
        this.url = "";
        this.part_numbers = [];
        this.client = new Client();
        this.lob = new Lob();
        this.budget = 0;
    }
}

export class PartNumber {
    id?: number;
    part_number: string;
    amortize: boolean;

    constructor() {
        this.id = undefined;
        this.part_number = "";
        this.amortize = true;
    }
}

export class AssociateProject {
    project_id: number;
    project_name: string;

    constructor() {
        this.project_id = 0;
        this.project_name = "";
    }
}

export const statusList: SelectItem[] = [
    {label: 'all', value: '0'},
    {label: 'active', value: 'active'},
    {label: 'inactive', value: 'inactive'},
]
